/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const DownloadIcon = createIcon(
  '0 0 20 20',
  <g>
    <path d="M4 16h12v-3h2v5H2v-5h2z" />
    <path d="M11 8h3l-4 6-4-6h3V3h2z" />
  </g>,
);
